var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{staticClass:"notice-swiper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.list),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-item"},[_c('div',{staticClass:"roll-list"},[_vm._v(_vm._s(item))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }